<template lang='pug'>
  v-row(no-gutters)
    a(href='https://github.com/apps/bionic-metrics') Install GitHub App
</template>

<script>
export default {
  name: 'GitHubInstall'
};
</script>

<style scoped>

</style>
